import script from "./Hero.vue?vue&type=script&setup=true&lang=ts"
export * from "./Hero.vue?vue&type=script&setup=true&lang=ts"

import "./Hero.vue?vue&type=style&index=0&id=4fa95e29&lang=scss"

const __exports__ = script;

export default __exports__